function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Duplicated from ab-common

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function handleSingleArrayElement(arr) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  if (arr.length !== 1) return arr;
  var retValue = _objectSpread({}, arr[0]);
  Object.defineProperty(retValue, 'length', {
    value: 1,
    writable: false,
    enumerable: false,
    configurable: false
  });
  Object.defineProperty(retValue, 0, {
    value: retValue,
    writable: false,
    enumerable: false,
    configurable: false
  });
  return retValue;
}
export var fetchRelationships = function fetchRelationships(store, relationshipArray) {
  if (!store || !store.api || !store.api.entities) return [];
  if (!relationshipArray || !Array.isArray(relationshipArray)) return [];
  var relationships = [];
  try {
    relationships = relationshipArray.map(function (_ref) {
      var type = _ref.type,
        id = _ref.id;
      var entity = store.api.entities[type][id];
      if (!entity) return null;
      var element = _objectSpread(_objectSpread({}, entity.attributes), {}, {
        id: parseInt(id, 10)
      });
      if (entity.links) element.links = entity.links;
      if (entity.meta) element.meta = entity.meta;

      // Nested relationships
      if (entity.relationships) {
        Object.keys(entity.relationships).forEach(function (relationshipKey) {
          var relationships = entity.relationships[relationshipKey];
          if (relationships.data) {
            var data = Array.isArray(relationships.data) ? relationships.data : [relationships.data];
            var elements = fetchRelationships(store, data);
            if (Array.isArray(relationships.data)) {
              element[relationshipKey] = elements;
            } else {
              element[relationshipKey] = handleSingleArrayElement(elements);
            }
          }
        });
      }
      return element;
    });
  } catch (err) {
    // console.error(err);
  }
  return relationships;
};
export var buildObjectRelationship = function buildObjectRelationship(entity, entityList) {
  if (!entity || !entityList) return entity;
  var store = {
    api: {
      entities: entityList
    }
  };
  var relationships = {};
  Object.keys(entity.relationships).filter(function (relationshipKey) {
    return entity.relationships[relationshipKey].data;
  }).forEach(function (relationshipKey) {
    var data = Array.isArray(entity.relationships[relationshipKey].data) ? entity.relationships[relationshipKey].data : [entity.relationships[relationshipKey].data];
    var relationshipData = fetchRelationships(store, data);
    if (Array.isArray(entity.relationships[relationshipKey].data)) {
      relationships[relationshipKey] = relationshipData;
    } else {
      relationships[relationshipKey] = handleSingleArrayElement(relationshipData);
    }
  });
  return _objectSpread(_objectSpread({
    id: entity.id
  }, entity.attributes), relationships);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var buildObjectList = function buildObjectList(store, objectType, requestResult) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  if (!store || !store.api || !store.api.entities) return [];
  var entitiesRoot = store.api.entities;
  var originalArray = entitiesRoot[objectType];
  var relationshipCache = {};
  if (!originalArray) return [];
  var baseList = null;
  if (requestResult) {
    baseList = requestResult.filter(Boolean).map(function (_ref2) {
      var type = _ref2.type,
        id = _ref2.id;
      return entitiesRoot[type][id];
    });
  } else {
    baseList = Object.keys(originalArray).map(function (key) {
      return originalArray[key];
    });
  }

  // Warning: this function purposely changes the `elements` parameter.
  var _relationships = function _relationships(element, relationships) {
    if (!relationships) return;
    Object.keys(relationships).forEach(function (relationshipKey) {
      var relationship = relationships[relationshipKey];
      if (!relationship) {
        console.warn("cannot find relationship ".concat(relationshipKey));
        element[relationshipKey] = null;
        return;
      }
      if (!relationship.data) {
        element[relationshipKey] = null;
        return;
      }
      if (!relationshipCache[relationshipKey]) relationshipCache[relationshipKey] = {};
      if (!Array.isArray(relationship.data)) {
        var entityData = entitiesRoot[relationship.data.type][relationship.data.id];
        var id = parseInt(entityData.id, 10);
        if (relationshipCache[relationshipKey][id]) {
          element[relationshipKey] = relationshipCache[relationshipKey][id];
        } else {
          var result = _objectSpread(_objectSpread({}, entityData.attributes), {}, {
            id: id,
            meta: entityData.meta
          });
          relationshipCache[relationshipKey][id] = result;
          element[relationshipKey] = result;
          if (entityData.links) result.links = entityData.links;

          // Fetch nested relationships
          _relationships(result, entityData.relationships);
        }
      } else {
        element[relationshipKey] = fetchRelationships(store, relationship.data);
      }
    });
  };
  return baseList.map(function (_ref3) {
    var id = _ref3.id,
      attributes = _ref3.attributes,
      relationships = _ref3.relationships,
      meta = _ref3.meta,
      links = _ref3.links;
    var order = _objectSpread(_objectSpread({}, attributes), {}, {
      id: parseInt(id, 10),
      meta: meta,
      links: links
    });
    _relationships(order, relationships);
    return order;
  });
};
export default buildObjectList;